import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BiometricsInitComponent } from './biometrics-init/biometrics-init.component';
import { BiometricsInstructionsComponent } from './biometrics-instructions/biometrics-instructions.component';
import { BiometricsLauncherComponent } from './biometrics-launcher/biometrics-launcher.component';
import { BiometricsResultComponent } from './biometrics-result/biometrics-result.component';
import { BiometricsRoutingModule } from './biometrics-routing.module';
import { BiometricsUploadComponent } from './biometrics-upload/biometrics-upload.component';
import { BiometricsValidatorComponent } from './biometrics-validator/biometrics-validator.component';

@NgModule({
  declarations: [
    BiometricsValidatorComponent,
    BiometricsInstructionsComponent,
    BiometricsLauncherComponent,
    BiometricsResultComponent,
    BiometricsUploadComponent,
    BiometricsInitComponent
  ],
  imports: [CommonModule, BiometricsRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BiometricsModule {}
